import { t } from '../../../../common/i18n.js'
import type { Language } from '../../../../common/types/i18n.js'
import { normalizePhone } from '../../../../common/utils/format-utils.js'
import type { TextFieldNoteProps } from '../../../components/forms/text-field/text-field.js'

/** Example shape shown in every phone input (TASK-612). */
export const PHONE_PLACEHOLDER = '+372 5123 4567'

/**
 * Inline warning for a phone input whose value the server would reject
 * (PHONE_COUNTRY_CODE_REQUIRED) — lets the user fix the number before the
 * save round-trip. Empty and acceptable values get no note.
 */
export const phoneFieldNote = (value: string, lang: Language): TextFieldNoteProps | undefined =>
    normalizePhone(value).ok
        ? undefined
        : { text: t.portal.profile.phoneCountryCodeHint(lang), isError: true }
